<section *ngIf="!isLoading" class="i-services flex flex-col justify-center items-center">
	<div class="i-service-doc-c i-font-primary flex justify-between items-stretch
	max-w-screen-xl w-full mt-5 md:mt-20  min-h-screen ">
		<div class="i-s-sidebar-c md:flex-[18%] w-full relative bmx-hide-sm bmx-hide-xs">
			<fb-blog-details-toc class="i-sticky top-[80px]" [blogDetails]="blogDetails"
								 (showFaqCollapsed)="showFaqCollapsed = $event"
								 [service]="'content/' + this.generateUrl.getUrl(blogDetails.blogContentCategory.blogContentType? blogDetails.blogContentCategory.blogContentType.name: '')"></fb-blog-details-toc>
		</div>
		<div class="i-s-content-c flex-[100%] flex flex-col md:flex-row justify-between items-start md:flex-[82%] w-full relative mb-[100px] md:mb-[200px]">
			<div class="w-full flex-[100%] md:flex-[80%] px-2 md:px-8 max-w-[839px]">
				<fb-blog-details-content [blogDetails]="blogDetails"
										 [blogRecommendedList]="blogRecommended"
										 [showCollapsedFaqs]="showFaqCollapsed"
										 [contentTypeUrl]="'/content/' + this.generateUrl.getUrl(blogDetails.blogContentCategory.blogContentType? blogDetails.blogContentCategory.blogContentType.name: '') + '/'"></fb-blog-details-content>
			</div>
			<div class="i-s-anchor-c flex-[100%] md:flex-[20%] w-full">
				<fb-blog-details-about class="relative w-full "
									   [blogDetails]="blogDetails"
									   [blogRecommendedList]="blogRecommended"
									   [contentTypeUrl]="'/content/' + this.generateUrl.getUrl(blogDetails.blogContentCategory.blogContentType? blogDetails.blogContentCategory.blogContentType.name: '') + '/'"></fb-blog-details-about>
			</div>
		</div>
	</div>
	<div class="bmx-hide-xl bmx-hide-lg bmx-hide-md fixed top-[85px] right-3 z-[1] ">
		<div class="flex flex-col items-center justify-center w-[220px]">
			<div class="w-full flex justify-end">
				<button (click)="toggleDropdown()" class="i-anchor-mobile flex px-2 rounded">
					<div class="mr-1 text-sm mt-1">On this Page </div>
					<svg width="15" height="28" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" style="height: 100%"><path d="M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
				</button>
			</div>

			<div *ngIf="dropdown" class="i-anchor-dropdown bg-[#fffcf7] px-2 py-3 rounded-2xl mt-2">
				<fb-blog-details-toc (click)="toggleDropdown()" [blogDetails]="blogDetails"
									 (showFaqCollapsed)="showFaqCollapsed = $event"
									 [service]="'content/' + this.generateUrl.getUrl(blogDetails.blogContentCategory.blogContentType? blogDetails.blogContentCategory.blogContentType.name: '')"></fb-blog-details-toc>
			</div>
		</div>

	</div>




</section>
<fb-loader *ngIf="isLoading"></fb-loader>

<!--<div [ngClass]="sidebar? 'closed':''"-->
<!--	 class="i-side-mobile bmx-hide-xl bmx-hide-lg bmx-hide-md">-->
<!--	<i-service-sidebar class=""></i-service-sidebar>-->
<!--</div>-->
